import GoogleMapService from "./googleMapService";
import AppleMapService from "./appleMapService";

export default class MapService {
  static async create(provider, containerId, options = {}, credentials = {}) {
    let service;
    switch (provider) {
      case "google":
        service = new GoogleMapService(containerId, options);
        await service.init(credentials.apiKey);
        break;
      case "apple":
        service = new AppleMapService(containerId, options);
        await service.init(credentials.token);
        break;
      default:
        throw new Error(`Unsupported map provider: ${provider}`);
    }
    return service;
  }
}
